import { render, staticRenderFns } from "./tabeliao.vue?vue&type=template&id=2268a3d4&"
import script from "./tabeliao.vue?vue&type=script&lang=js&"
export * from "./tabeliao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports